/**
 * Asynchronously loads the component for NotAuthorizedPage
 */

import { lazyLoad } from 'utils/loadable';

export const NotAuthorizedPage = lazyLoad(
  () => import('./index'),
  module => module.NotAuthorizedPage,
);
